/**
 * @generated SignedSource<<2db512079d2702d8250d497a322facd7>>
 * @relayHash 9ef9e1a3049c4fffafa3420952f59d9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2825c1f69d3a2b20bb3597f8de8b101659ed227bd89e5554026122895f1e1ed

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalSidebarAggQuery$variables = {
  containerId: string;
  isCombinedAggQueryEnabled: boolean;
  searchQuery: string;
};
export type GoalSidebarAggQuery$data = {
  readonly townsquare: {
    readonly goalTql?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"GoalSidebarAgg">;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type GoalSidebarAggQuery = {
  response: GoalSidebarAggQuery$data;
  variables: GoalSidebarAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCombinedAggQueryEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "searchQuery"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "canAddLinkedGoals"
},
v7 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v8 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v9 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "end"
},
v13 = {
  "kind": "ScalarField",
  "name": "start"
},
v14 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v15 = {
  "kind": "ScalarField",
  "name": "value"
},
v16 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalSidebarAggQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "condition": "isCombinedAggQueryEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "goalTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "GoalSidebarAgg"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalSidebarAggQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "condition": "isCombinedAggQueryEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "goalTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canAddWatchers"
                              },
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedGoals"
                              },
                              {
                                "concreteType": "TownsquareGoalAppCapabilities",
                                "kind": "LinkedField",
                                "name": "apps",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canManageOwnership"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddTeams"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveTeams"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditStartDate"
                              },
                              {
                                "concreteType": "TownsquareGoalAppCapabilities",
                                "kind": "LinkedField",
                                "name": "apps",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canManagePeriodicMetricTargets"
                                  },
                                  (v7/*: any*/)
                                ]
                              },
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canAddLinkedFocusAreas"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedFocusAreas"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditCustomFields"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddTags"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveTags"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "count"
                              },
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      (v11/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "kind"
                              },
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareTargetDateRange",
                                "kind": "LinkedField",
                                "name": "dateRange",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v13/*: any*/),
                                                          (v12/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v15/*: any*/),
                                                  (v10/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v4/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v16/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accessLevel"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "creationDate"
                          },
                          {
                            "args": (v17/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalIcon",
                                        "kind": "LinkedField",
                                        "name": "icon",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "appearance"
                                          }
                                        ]
                                      },
                                      (v11/*: any*/),
                                      {
                                        "concreteType": "TownsquareMetricTargetConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargets",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTarget",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "startValue"
                                                  },
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargetPeriods",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareMetricTargetPeriod",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "TownsquareTargetDate",
                                                                "kind": "LinkedField",
                                                                "name": "date",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v14/*: any*/),
                                                                  {
                                                                    "concreteType": "TownsquareTargetDateRange",
                                                                    "kind": "LinkedField",
                                                                    "name": "dateRange",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v13/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v15/*: any*/),
                                                              {
                                                                "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
                                                                "kind": "LinkedField",
                                                                "name": "latestValue",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "TownsquareMetricValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v15/*: any*/),
                                                                      (v4/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v4/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v4/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalCapabilities",
                                        "kind": "LinkedField",
                                        "name": "capabilities",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v10/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                  }
                                ]
                              },
                              {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                  }
                                ]
                              },
                              (v16/*: any*/)
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "args": (v17/*: any*/),
                            "handle": "connection",
                            "key": "useGoalSuccessMeasureCapabilitiesConnection_successMeasures",
                            "kind": "LinkedHandle",
                            "name": "successMeasures"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f2825c1f69d3a2b20bb3597f8de8b101659ed227bd89e5554026122895f1e1ed",
    "metadata": {},
    "name": "GoalSidebarAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "55be154d735d6ecd765f5644c82203ad";

export default node;
